'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabManager = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _styles = require('@material-ui/core/styles');

var _CaptureContent = require('./CaptureContent');

var _CaptureContent2 = _interopRequireDefault(_CaptureContent);

var _constants = require('../constants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Converts child Nodes into an array of objects
 * and caches the results.
 */
var TabManager = exports.TabManager = function (_React$Component) {
  (0, _inherits3.default)(TabManager, _React$Component);

  function TabManager() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TabManager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TabManager.__proto__ || (0, _getPrototypeOf2.default)(TabManager)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      childList: [],
      screenSizeKey: (0, _constants.getScreenSizeKey)(),
      isIndexed: false
    }, _this.setTabInfo = function (_ref2) {
      var index = _ref2.index,
          to = _ref2.to,
          childProps = (0, _objectWithoutProperties3.default)(_ref2, ['index', 'to']);
      return function (_ref3) {
        var children = _ref3.children,
            isRambling = _ref3.isRambling,
            width = _ref3.width;

        var childList = _this.state.childList;

        var tab = (0, _extends3.default)({}, childProps, {
          index: index,
          to: to,
          children: children,
          isRambling: isRambling,
          width: width
        });

        childList.push(tab);

        _this.setState({
          childList: childList,
          isIndexed: true
        });
      };
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TabManager, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          rawInput = _props.rawInput,
          classes = _props.classes;
      var _state = this.state,
          childList = _state.childList,
          isIndexed = _state.isIndexed,
          screenSizeKey = _state.screenSizeKey;


      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: classes.visuallyHidden },
          React.Children.map(rawInput, function (_ref4, index) {
            var props = _ref4.props;
            var to = props.to,
                label = props.label,
                passThroughProps = (0, _objectWithoutProperties3.default)(props, ['to', 'label']);


            return React.createElement(
              _CaptureContent2.default,
              {
                key: index,
                maxWidth: _constants.MAX_TAB_CONTENT_WIDTH_MAP[screenSizeKey],
                onWidthSet: _this2.setTabInfo((0, _extends3.default)({
                  index: index,
                  to: to
                }, passThroughProps))
              },
              label
            );
          })
        ),
        isIndexed && React.Children.map(children, function (child) {
          return React.cloneElement(child, {
            childrenAsPropsList: childList
          });
        })
      );
    }
  }]);
  return TabManager;
}(React.Component);

TabManager.defaultProps = {
  classes: {}
};


var styleSheet = {
  visuallyHidden: {
    position: 'absolute',
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    height: 1,
    width: 1,
    margin: -1,
    padding: 0,
    border: 0
  }
};

exports.default = (0, _styles.withStyles)(styleSheet)(TabManager);